import Shell from "./Shell";
import { SUPPORT_EMAIL, YEARLY_PRODUCT_ID } from "./constants";

const faqs = [
  {
    title: "Restore purchases",
    body: "Nightdrift Premium is purchased with your Apple ID through StoreKit. There is no Nightdrift account to sign in to. On your device, open Nightdrift and choose Restore Purchases. Apple restores the active subscription for that Apple ID onto this device. Use the same Apple ID you used to start the trial or subscribe. If Premium does not unlock, confirm the subscription is active in your App Store account settings, then email support.",
  },
  {
    title: "Manage or cancel the subscription",
    body: "The subscription renews through Apple. On an iPhone or iPad, open Settings, tap your name, then tap Subscriptions, and select Nightdrift Premium. You can cancel or turn off auto-renew there. You can also open the App Store, tap your account, and open Subscriptions. Deleting the app does not cancel the subscription. After you cancel, you keep access until the end of the period you already paid for.",
  },
  {
    title: "Free trial",
    body: "Nightdrift Premium (" + YEARLY_PRODUCT_ID + ") includes a 7-day free trial, then $0.99 USD per year. If you do not cancel at least 24 hours before the trial ends, the trial converts to a paid yearly subscription and Apple charges your Apple ID. The price shown in your App Store storefront at confirmation is the price you pay. Cancel in your Apple ID subscription settings at least 24 hours before the trial ends to avoid that charge.",
  },
  {
    title: "Background playback",
    body: "Sounds keep playing when you lock the screen or leave Nightdrift. The Lock Screen and Control Center show playback controls, so you can pause or play without opening the app. A sleep timer keeps counting down and fades the sound out when it ends.",
  },
  {
    title: "Contact support",
    body: "Email " + SUPPORT_EMAIL + ". Say what you expected to happen. If you want help with a purchase, include the Apple ID email you subscribed with. We use that message only to reply. Do not send your Apple ID password.",
  },
];

function Support() {
  return (
    <Shell>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-white shadow rounded-lg p-6">
          <h2 className="text-xl font-bold text-gray-900">Support</h2>
          <p className="text-gray-700 mt-4">
            Our goal is to help you drift off peacefully. For any questions, suggestions, or feedback then please reach out at the email address below.
          </p>
          <div className="mt-6 flex items-center">
            <a href={"mailto:" + SUPPORT_EMAIL} className="text-blue-500 hover:text-blue-600">{SUPPORT_EMAIL}</a>
          </div>
        </div>
        {faqs.map((faq) => (
          <div className="bg-white shadow rounded-lg p-6" key={faq.title}>
            <h2 className="text-xl font-bold text-gray-900">{faq.title}</h2>
            <p className="text-gray-700 mt-4">{faq.body}</p>
          </div>
        ))}
      </div>
    </Shell>
  );
}

export default Support;
